import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Toggle } from '@updox/ui-components';
import UserMultiSelect from '../UserMultiSelect/UserMultiSelectContainer';
import * as types from '../../constants/ActionTypes';
import { PRIVATE_CHANNEL_LABEL, PUBLIC_CHANNEL_LABEL } from '../../constants/AppConstants';

import classnames from 'classnames';

export default class CreateChannel extends Component {
  static propTypes = {
    createChannelError: PropTypes.string,
    startChannel: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
  };

  initialState = {
    name: '',
    userIds: [],
    isPrivate: true,
    touched: false,
    error: '',
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.props.clearError(types.START_CHANNEL);
  }

  validate = () => {
    const { name } = this.state;
    let error = '';
    if (!name) {
      error = 'Required';
    }
    if (name.length > 128) {
      error = 'Name must be 128 characters or less';
    }

    this.setState({ error });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { startChannel } = this.props;
    this.setState({ error: '', touched: false }, () => startChannel(this.state));
  };

  clearSelectedUsers = () => this.setState({ userIds: [] });

  onChangeHandler = (e) => {
    const name = e.target.value;
    this.setState({ name, touched: true }, this.validate);
    const { clearError, createChannelError } = this.props;

    if (createChannelError) {
      clearError(types.START_CHANNEL);
    }
  };

  render() {
    const { createChannelError } = this.props;
    const { name, isPrivate, userIds, error, touched } = this.state;
    const toggleLabelStyle = {
      display: 'inline-block',
      fontSize: '12px',
      position: 'absolute',
      textAlign: 'center',
      top: '3px',
      width: '100%',
      zIndex: '1',
    };

    return (
      <form className="create-channel" onSubmit={this.handleSubmit}>
        <p>Channels are areas where communications are centered around a particular topic, such as <strong>billing</strong> or <strong>nurses</strong>.</p>
        <div className="channel-type">
          <Toggle
            className={isPrivate ? 'toggle-overrides' : ''}
            labelStyle={toggleLabelStyle}
            label={isPrivate ? PRIVATE_CHANNEL_LABEL : PUBLIC_CHANNEL_LABEL}
            title={isPrivate ? PRIVATE_CHANNEL_LABEL : PUBLIC_CHANNEL_LABEL}
            name={isPrivate ? 'isPrivate' : 'isPublic'}
            id={isPrivate ? 'isPrivate' : 'isPublic'}
            onChange={e => this.setState({ isPrivate: e.target.checked })}
            onBlur={this.validate}
            qaId={isPrivate ? 'isPrivateToggle' : 'isPublicToggle'}
            type='checkbox'
            checked={isPrivate}
          />
          <label htmlFor={isPrivate ? 'isPrivate' : 'isPublic'}>
            {isPrivate ?
              'Only people with an invite can access Private Channels'
              :
              'Anyone can search and join a Public Channel'
            }
          </label>
        </div>
        <div className={classnames({
          'error': true,
          'visible': error || createChannelError,
        })}>
          {error || createChannelError}
        </div>
        <label htmlFor='channelNameInput'>Channel name</label>
        <input
          id='channelNameInput'
          type='text'
          name='name'
          className={(error || createChannelError) && 'not-valid'}
          autoComplete='off'
          autoFocus
          value={name}
          placeholder="Choose a descriptive name"
          onChange={e => this.onChangeHandler(e)}
          onBlur={() => this.validate()}
        />
        <label htmlFor='userInviteInput'>Invite Users</label>
        <UserMultiSelect
          inputPlaceholderText="Invite users to this channel"
          id="userInviteInput"
          qaId="userInvite"
          excludeSelfUser
          onChange={userIds => this.setState({ userIds })}
          onClearAll={this.clearSelectedUsers}
          value={userIds}
        />
        <button
          className="btn primary create-btn"
          type="submit"
          disabled={error || !touched}
        >
          Create Channel
        </button>
      </form>
    );
  };
}
